import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "@environments/environment";
import {Location} from "@angular/common";

@Component({
  selector: 'app-privacy-page',
  templateUrl: './privacy-page.component.html',
  styleUrls: ['./privacy-page.component.scss']
})
export class PrivacyPageComponent implements OnInit {

  privacyContent: string;

  constructor(
    private httpClient: HttpClient,
    private location: Location
  ) {

  }

  ngOnInit(): void {
    if (!environment.showPrivacyPolicy) {
      this.location.back();
    }
    // this.fetchPrivacy();
  }

  async fetchPrivacy() {
    this.privacyContent = (await this.httpClient.get(environment.privacy.endpoint).toPromise())['content'];
  }

}
